import moment, { Moment } from 'moment';
import { IndexData, MarketDateFilter } from "models/types";
import { getCurrentDate } from 'utils/date';

export function getDateSortedIndexData(indexData: IndexData[]): IndexData[] {
    return indexData.filter(indexData => indexData.date != null)
    .sort((a, b) => {
        if (a.date && b.date) {
            return b.date.diff(a.date);
        }
        return 0;
    });
}

export function filterDataByMarketDateFilter(range: MarketDateFilter, indexData: IndexData[]): IndexData[] {
    const endDate = moment();
    let startDate: Moment;

    switch (range) {
        case MarketDateFilter.FIVE_YEARS:
            startDate = endDate.clone().subtract(5, 'years');
            break;
        case MarketDateFilter.THREE_YEARS:
            startDate = endDate.clone().subtract(3, 'years');
            break;
        case MarketDateFilter.ONE_YEAR:
            startDate = endDate.clone().subtract(1, 'years');
            break;
        case MarketDateFilter.YEAR_TO_DATE:
            startDate = endDate.clone().startOf('year');
            break;
        case MarketDateFilter.SIX_MONTHS:
            startDate = endDate.clone().subtract(6, 'months');
            break;
        default:
            return indexData;
    }
    return indexData.filter(d => moment(d.date).isBetween(startDate, endDate, undefined, '[]'));
};

export function getBackfilledIndexData(indexData: IndexData[]): IndexData[] {
    if (!indexData.length) return [];

    const sortedPriceData = getDateSortedIndexData(indexData).reverse();
    const startDate = sortedPriceData[0].date!;
    const endDate = getCurrentDate();

    let currentDate = startDate.clone();
    let currentIndex = 0;
    const backfilledData: IndexData[] = [];
    let foundFirstNonZero = false;

    while (currentDate.isSameOrBefore(endDate, 'day')) {
        if (sortedPriceData[currentIndex] && currentDate.isSame(sortedPriceData[currentIndex].date, 'day')) {
            backfilledData.push({
                date: currentDate.clone(),
                index: sortedPriceData[currentIndex].index,
                weightedIndex: sortedPriceData[currentIndex].weightedIndex,
                arp: sortedPriceData[currentIndex].arp,
                normalizedArp: sortedPriceData[currentIndex].normalizedArp
            });
            if (sortedPriceData[currentIndex].weightedIndex !== 0) {
                foundFirstNonZero = true;
            }
            currentIndex++;
        } else {
            const previousValue = backfilledData.length > 0 ? backfilledData[backfilledData.length - 1] : null;
            if (foundFirstNonZero || previousValue?.weightedIndex !== 0) {
                backfilledData.push({
                    date: currentDate.clone(),
                    index: previousValue?.index || 0,
                    weightedIndex: previousValue?.weightedIndex || 0,
                    arp: previousValue?.arp || 0,
                    normalizedArp: previousValue?.normalizedArp || 0
                });
            }
        }
        currentDate.add(1, 'day');
    }

    return backfilledData;
}